import { Component, effect, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseTunnelObject } from '../../model/base-tunnel-object';
import { CONFIG_CONTEXT } from '../../../../enum/config-context.enum';
import { TunnelDataStore } from '../../../../stores/tunnel/tunnel-data.store';
import { TunnelNavigationStore } from '../../../../stores/tunnel/tunnel-navigation.store';
import { BasketConfigurationData } from '../../../../stores/tunnel/model/configuration-data/basket-configuration-data';
import { Price } from '../../../../stores/tunnel/model/price';
import { PurchaseListStore } from '../../../../stores/purchase-list.store';
import { BasketService } from '../../../../services/basket.service';
import { isGuidValue } from '../../../../services/helpers/utils';
import { TunnelCartService } from '../../common/purchase-list/services/tunnel-cart.service';
import { BasketCartService } from '../services/basket-cart.service';

/**
 * Étape « Liste d'achat » du tunnel panier.
 * Assemble la recherche produit et le panneau des produits sélectionnés, et reporte le contenu du
 * {@link PurchaseListStore} dans le {@link TunnelDataStore}.
 */
@Component({
  selector: 'ng-casto-basket-tunnel-products',
  templateUrl: './basket-tunnel-products.component.html',
  styleUrls: ['./basket-tunnel-products.component.scss'],
  providers: [{ provide: TunnelCartService, useExisting: BasketCartService }],
})
export class BasketTunnelProductsComponent extends BaseTunnelObject {
  private readonly purchaseListStore = inject(PurchaseListStore);
  private readonly basketService = inject(BasketService);
  private readonly route = inject(ActivatedRoute);

  constructor() {
    const tunnelNavigationStore = inject(TunnelNavigationStore);
    const tunnelDataStore = inject(TunnelDataStore);
    super(tunnelNavigationStore, tunnelDataStore);

    effect(() => this.syncConfigurationData());
  }

  override ngOnInit(): void {
    super.ngOnInit();

    const startIndex = this.route.snapshot.params['startIndex'];
    if (isGuidValue(startIndex)) {
      void this.basketService.loadPurchaseListFromConfiguration(startIndex);
    }
  }

  protected subscribeToObservable(): void {}

  /** Reporte le nombre d'articles et le total de la liste d'achat dans les données du tunnel. */
  private syncConfigurationData(): void {
    const total = this.purchaseListStore.totalListPrice();

    this.tunnelDataStore.updateConfigurationData(CONFIG_CONTEXT.BASKET, {
      configurationId: this.basketService.configuration?.id,
      productCount: this.purchaseListStore.totalItemCount(),
    } as BasketConfigurationData);

    this.tunnelDataStore.updateCurrentPricing({
      totalWithoutFunding: new Price({ baseAmount: total, actualAmount: total }),
    });
  }
}
